import { Core } from "@faire/design-tokens";
import styled from "styled-components";
export var IconWrapper = styled.div.withConfig({
  displayName: "styles__IconWrapper"
})(["border-radius:50%;padding:24px;background:", ";width:72px;height:72px;text-align:center;"], Core.surface.subdued);